import '../App.css';

export const Text = () => {
    return (
        <>
            <p>
                Esta es la página informativa para l@s conductor@s de Moove, que hemos creado los delegados
                de UGT.
            </p>

            {/* <p>
                Aquí tendrás toda la información, asi como las respuestas a tus posibles preguntas.
            </p> */}
        </>
    )
}